// extracted by mini-css-extract-plugin
export default {"todolist":"TodoList_todolist__wQMTP"};